export const SUPPLIER_INVENTORY = 'SUPPLIER_INVENTORY';
export const SUPPLIER_INVENTORY_OFFSET = 'SUPPLIER_INVENTORY_OFFSET';
export const SUPPLIER_INVENTORY_PER_PAGE = 'SUPPLIER_INVENTORY_PER_PAGE';
export const SUPPLIER_INVENTORY_COUNT = 'SUPPLIER_INVENTORY_COUNT';
export const SUPPLIER_INVENTORY_SEARCH = 'SUPPLIER_INVENTORY_SEARCH';
export const SUPPLIER_INVENTORY_LOADING = 'SUPPLIER_INVENTORY_LOADING';
export const SUPPLIER_INVENTORY_LOADING_PRODUCTS = 'SUPPLIER_INVENTORY_LOADING_PRODUCTS';
